import { useTranslation } from "react-i18next";
import { StreamEntrypoints as StreamEntrypointsFeature } from "@/partner/features/streamEntrypoints";
import { Meta } from "@/shared/components";

export function StreamEntrypointsPage() {
  const { t } = useTranslation();

  return (
    <>
      <Meta title={t("streamEntrypoints.listTitle")} pageType="Partner" />
      <StreamEntrypointsFeature />
    </>
  );
}
